import styled from "styled-components";
import type { GlobalToken } from "antd";

export const WarningChip = styled.span<{ $token: GlobalToken }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 44px;
  height: 44px;
  border-radius: ${({ $token }) => $token.borderRadiusLG}px;
  color: ${({ $token }) => $token.colorWarning};
  background: ${({ $token }) => $token.colorWarningBg};
`;

export const Message = styled.p<{ $token: GlobalToken }>`
  margin: 0;
  color: ${({ $token }) => $token.colorTextSecondary};
  font-size: ${({ $token }) => $token.fontSize}px;
  line-height: 1.5;

  strong {
    color: ${({ $token }) => $token.colorText};
    font-weight: ${({ $token }) => $token.fontWeightStrong};
  }
`;
